import { useMemo } from 'react';
import type { ISerializableObject, ISerializableObjectClass } from './ObjectRepository';
import { ObjectRepository } from './ObjectRepository';
import type { DBPath } from 'balus-common';

export const useObjectRepository = <DumpType, ObjectType extends ISerializableObject<DumpType>>(
  objectClass: ISerializableObjectClass<DumpType, ObjectType>,
  path: DBPath
): ObjectRepository<DumpType, ObjectType> => {
  return useMemo(() => {
    return new ObjectRepository<DumpType, ObjectType>(objectClass, path);
  }, [objectClass, path]);
};
